/* Hover sur le menu desktop */
$('.header__nav > li > .sub-menu').hover(
    function() {
        $(this).prev('a').addClass('js-hover');
    }, function() {
        $(this).prev('a').removeClass('js-hover');
    }
)
